import React from 'react';
import { Input, Button, Box } from '@chakra-ui/react';
import './../StylesPages/mdpoublie.css';
import { Parse } from 'parse';
import { useState } from 'react';

function MdpOublie() {

    const [email, setEmail] = useState('');


    const handleSubmit = e => {
        const currentUser = Parse.User.current();
        if (currentUser) {
            Parse.User.requestPasswordReset(email)
                .then(() => {
                    alert("Reset Password Success")
                }).catch((error) => {
                    alert("Error: " + error.code + " " + error.message);
                });
        }
    }

    document.body.style = 'background: #0080FF;';

    return (
        <Box className='mdpoublie_main_box'>
            <h2>Mot de passe oublié</h2>

            <form className='mdpoublie_form' onSubmit={handleSubmit}>
                <Box className='mdpoublie_input_box'>
                    <Input
                        placeholder="Email"
                        bg="white"
                        id="email"
                        borderRadius="20px"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        errorBorderColor="red.300"
                    />
                </Box>
                <Box>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="btn"
                    >
                        Envoyer
                    </Button>
                </Box>
            </form>
        </Box>
    );
}

export default MdpOublie